import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'
import { ISignupParameters } from 'services/auth/auth.slice'

export const instance = new CachedRequest(1000 * 5)

export async function apiSignup(args: ISignupParameters) {
  return instance.post(endpoint.signup, args)
}